<template>
  <b-card class="mini-stats-wid">
    <div class="media" v-if="!loading">
      <div class="media-body">
        <p class="text-muted fw-medium mb-2">{{ title }}</p>
        <h4 class="mb-0">{{ value }}</h4>
      </div>

      <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
          <span class="avatar-title">
            <i :class="`${icon} font-size-24`"></i>
          </span>
      </div>
    </div>
    <b-spinner
        v-else
        class="m-2"
        variant="primary"
        role="status"
    ></b-spinner>
    <!-- end card-body -->
  </b-card>
  <!-- end card -->
</template>

<script>
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: 0
    },
    icon: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>